import i18next from "i18next";
import { IQuantity, Quantity } from "../../../../common/models/quantity.model";

export const generateNew = (quantity: IQuantity, actions: any, selectedOrder?: any) => {
  const t = i18next.getFixedT(null, "admin");
  const items = [{
    key: "delete",
    text: t("orders.commandBar.cancelOrder"),
    iconProps: { iconName: "delete" },
    name: "delete",
    onClick: actions.setOrderCanceled,
  },
  {
    key: "activate",
    text: t("orders.commandBar.acceptOrder"),
    iconProps: { iconName: "followUser" },
    name: "activate",
    onClick: actions.setOrderAccepted,
  },]

  const cuoSplitsButton = selectedOrder && selectedOrder.isFromCuo === "CUO" && selectedOrder.currentStatus === 1 ? [{
    key: "cuoSplits",
    text: t("orders.commandBar.manageCuoSplits"),
    iconProps: { iconName: "BranchMerge" },
    name: "cuoSplits",
    onClick: actions.openCuoSplitsPanel,
  }] : [];

  switch (quantity) {
    case Quantity.NONE:
      return [
        {
          key: "add",
          text: t("orders.commandBar.add"),
          iconProps: { iconName: "add" },
          onClick: actions.addNewOrder,
        },
      ];
    case Quantity.ONE:
      return [
        {
          key: "see",
          text: t("orders.commandBar.see"),
          iconProps: { iconName: "textDocument" },
          onClick: actions.openPanelToSee,
        },
        {
          key: "add",
          text: t("orders.commandBar.edit"),
          iconProps: { iconName: "edit" },
          onClick: actions.openPanel,
        },
        ...cuoSplitsButton,
        ...items
      ];
    case Quantity.MANY:
      return [
        ...items
      ];
  }
};
